import React from 'react'
import rzlfh from '../images/rzlfh-icon.svg'
import lightdesign from '../images/light-design.svg'
import Heading from '../components/Heading'
import Designdata from '../components/Designdata'
import { useEffect, useState } from 'react'
import ListDesign from '../components/ListDesign'
import ScrollToTop from '../components/ScrollToTop'
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '60%',
    height: '100%',
    overflow: 'auto'
};

const Design = () => {

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    const [open, setOpen] = useState(false);
    const [currentIdx, setCurrentIdx] = useState(null);

    const handleOpen = (idx) => {
        setCurrentIdx(idx);
        setOpen(true);
    }

    const handleClose = () => {
        setCurrentIdx(null);
        setOpen(false);
    }

    return (
        <>
            <img src={lightdesign} alt="lightfe" className='absolute top-0  right-0 w-[80%] -z-10' />

            <main className='px-8 md:px-[7.875em] lg:px-0 grid lg:grid-cols-6 text-center lg:text-left py-4 space-y-8 lg:space-y-12'>
                <div className='mt-[14em] lg:col-start-2 lg:col-end-6 lg:grid lg:grid-cols-4'>
                    <Heading text="Design & Illustration" />

                    {/* <ListDesign /> */}
                    <div className='lg:col-start-1 lg:col-end-5'>
                        <ImageList variant="masonry" cols={3} gap={16}>
                            {Designdata.map((item, idx) => (
                                <ImageListItem key={item.img}>
                                    <div className='relative hover:scale-[1.02] transition-all '>
                                        <img
                                            src={`${item.img}?w=248&fit=crop&auto=format`}
                                            srcSet={`${item.img}?w=248&fit=crop&auto=format&dpr=2 2x`}
                                            alt={item.title}
                                            loading="lazy"
                                            onClick={() => handleOpen(idx)}
                                        />
                                        <div className='absolute right-0 bottom-0 bg-gradient-to-t from-blackbg w-full h-[20%]'>
                                            <h3 className='absolute right-3 bottom-5 lg:text-[1.3rem]'>
                                                {item.title}
                                            </h3>
                                        </div>
                                    </div>
                                </ImageListItem>
                            ))}
                        </ImageList>
                    </div>

                    <Modal
                        open={open}
                        onClose={handleClose}
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description"
                    >
                        <Fade in={open}>
                            <div className='h-full grid w-[70%] md:w-[60%] mx-auto overflow-auto place-content-center'>
                                {Designdata[currentIdx] && (
                                    <img src={Designdata[currentIdx].img} alt={Designdata[currentIdx].title} className="h-full w-full" />
                                )}
                            </div>
                        </Fade>
                    </Modal>

                </div>
            </main>

            <ScrollToTop />

            <footer className='px-4 md:px-[7.875em] flex items-center justify-between  text-center py-8'>
                <img src={rzlfh} alt="rzlfh" className=' hidden md:block animate-spin-slow' />
                <ul className='flex items-center space-x-14 md:space-x-8 text-center  mx-auto md:mx-0'>
                    <li><a href="https://www.instagram.com/rzlfh/" className='underline opacity-70 hover:opacity-100 ' target="_blank">Instagram</a></li>
                    <li><a href="https://www.linkedin.com/in/rizal-fahadian-281b571b1/" className='underline opacity-70 hover:opacity-100' target="_blank">LinkedIn</a></li>
                    <li><a href="https://github.com/rzlfhh" className='underline opacity-70 hover:opacity-100' target="_blank">Github</a></li>
                </ul>
            </footer>
        </>
    )
}

export default Design

